import beamLogo from "@/assets/beam-logo.png";
import tjcSeal from "@/assets/tjc-seal.jpg.asset.json";

const link = "text-muted-foreground text-sm hover:text-primary transition-colors";

export function AudienceFooter() {
  return (
    <footer className="px-6 py-10 md:py-12 border-t border-border/30 bg-background">
      <div className="max-w-7xl mx-auto grid gap-8 md:grid-cols-[auto_1fr_1fr] md:gap-12 items-start">
        <div className="flex items-center gap-4">
          <img
            src={tjcSeal.url}
            alt="The Joint Commission Gold Seal of Approval"
            className="h-20 w-20 md:h-24 md:w-24 rounded-full shrink-0"
          />
          <div className="leading-tight">
            <p className="text-foreground font-semibold text-base md:text-lg">Joint Commission</p>
            <p className="text-muted-foreground text-sm">Accredited since 2017</p>
          </div>
        </div>

        <nav className="grid grid-cols-2 gap-x-8 gap-y-3" aria-label="Footer">
          <a href="/resources" className={link}>Resources</a>
          <a href="/critical-access-hospitals" className={link}>CAH Directory</a>
          <a href="/press" className={link}>Press</a>
          <a href="/terms-of-service" className={link}>Terms of Service</a>
          <a href="/privacy-policy" className={link}>Privacy Policy</a>
          <a href="https://www.beam.healthcare" className="text-primary text-sm hover:underline font-medium">beam.healthcare</a>
        </nav>

        <a
          href="https://beam.healthcare"
          target="_blank"
          rel="noopener"
          className="flex flex-col items-start md:items-end gap-2 hover:opacity-80 transition-opacity"
        >
          <img src={beamLogo} alt="Beam Healthcare" className="h-14 md:h-16 w-auto" />
          <span className="text-muted-foreground text-sm">© {new Date().getFullYear()} Beam Healthcare. All rights reserved.</span>
        </a>
      </div>
    </footer>
  );
}
